import SiteLayout from '../components/SiteLayout';
import StaticPage from '../components/StaticPage';
import { usePage } from '../hooks/useLocale';

export default function AdvisorsPage() {
  const { t, content } = usePage('advisors');

  return (
    <SiteLayout t={t}>
      <StaticPage content={content} showStats />
    </SiteLayout>
  );
}
